import UniqueId from '../../services/uid/UniqueId';
import { AppState } from '../reducers/root';
import { HierarchyStateEntity } from '../slices/hierarchy';

export const getHierarchyStateEntity = (
  state: AppState,
  categoryId: UniqueId
): HierarchyStateEntity => state.hierarchy[categoryId];

export const isHierarchyConnectedToForm = (
  state: AppState,
  treeId: UniqueId
): boolean => state.hierarchy[treeId].formId === treeId;
